import React, { useEffect } from "react";
import { Modal } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { updateUI } from "../../../store/actions/shipment";
import { ArrowLeftOutlined } from "@ant-design/icons";
import ShipmentCloneStep1 from "./step1";
import ShipmentCloneStep2 from "./step2";
import ShipmentCloneStep3 from "./step3";
import { IsRequiredValidation } from "./formValidation";
import { fetchDeviceRequest,fetchRequest,fetchProfileRequest,fetchAlertRequest,createRequest,updateshipRequest,fetchDeviceNameRequest } from "../../../store/actions/shipment";
import { useLocation, useNavigate } from "react-router-dom";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

function CloneShipment() {
  const dispatch = useDispatch();
  const shipmetProfile = useSelector((state) => state?.shipment?.data?.shipProfile);
  const { isCloneOpen, step, isSaved,editField,editRecord,cloneShipment } = useSelector((state) => ({
    isCloneOpen:state.shipment.ui.clone.isClone,
    step: state.shipment.ui.clone.step,
    isSaved: state.shipment.ui.clone.isSaved,
    editField: state.shipment.ui.clone.editField,
    editRecord:state.shipment.ui.clone.editRecord,
    cloneShipment:state.shipment.ui.clone
  }));
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isCloneOpen) {
      dispatch(fetchDeviceRequest());
      dispatch(fetchProfileRequest());
      dispatch(fetchAlertRequest());
      dispatch(fetchDeviceNameRequest());
      dispatch(fetchRequest());
    }
  }, [isCloneOpen,dispatch])
  const transformedBleDevices = Array.isArray(editRecord?.record?.bledevice)
    ? editRecord.record.bledevice
      .map(device => ({
        uid: device.id,
        name: device.name,
        deviceProfile: device.profile
      }))
    : [];
  const LastdeviceProfile = transformedBleDevices.length > 0
    ? transformedBleDevices[transformedBleDevices.length - 1].deviceProfile
    : null;
  function getDeviceDetails(devices, deviceProfile) {
    let result = devices?.find(device => device?.profilename === deviceProfile);
    if (result) {
      return {
        attributes: result?.attributes,
            name:result?.name
      };
    }
  }
  var extractedDetails = getDeviceDetails(shipmetProfile, LastdeviceProfile);
  useEffect(() => {
    if (!editRecord?.record) return;
    const fieldMapping = {
      shipmentName: "shipmentName",
      devicetype: "devicetype",
      profile: "customername",
     // isBLEEnabled: "enableble",
      onShipmentCompletion: "oncompletion",
      productSerialNumber: "productserialnumber",
      trackingNumber: "trackingnumber",
      orderNumber: "ordernumber",
      customerName: "customername",
      poNumber: "ponumber",
      state: "state",
      productId: "productid",
      selectProfile: "deviceprofile",
      shipmentid:"shipmentid",
      deviceId: "deviceid",
      devicename:"devicename",
      startDate:"startDate"
    };
    const updatedEditField = Object.keys(fieldMapping).reduce((acc, key) => {
      acc[key] = {
        ...editField[key],
        value: key === "shipmentName" && editRecord?.record?.editorClone === "clone"
          ? ""
          : key === "deviceId" && editRecord?.record?.editorClone === "clone"
          ?""
            : key === "startDate" && editRecord?.record?.editorClone === "clone"
              ? dayjs()
         :editRecord.record[fieldMapping[key]]
      };
      return acc;
    }, { ...editField });
    dispatch(
      updateUI({
        key: "clone",
        value: {
          editField: updatedEditField,
          selectedProfileId: editRecord.record.deviceprofile?.id,
         // ble: transformedBleDevices,
         // bleProfile: extractedDetails?.attributes,
        },
      })
    );
    if(location.pathname.includes("viewshipment")){
      navigate('/shipments');
    }
  }, [editRecord]);


  const handleOk = () => {
    dispatch(
      updateUI({
        key: "clone",
        value: {
          isClone: false,
        },
      })
    );
  };

  const handleAdd = () => {
    const response= dispatch(editRecord?.record?.editorClone === "clone" ?createRequest([cloneShipment]): updateshipRequest({ ...cloneShipment }));
    if (response?.payload[0]?.editField?.shipmentName?.value) {
      dispatch(
        updateUI({
          key: "clone",
          value: {
            isClone: false,
            step: 1,
          },
        })
      );
      dispatch(fetchRequest());
    }
  };
  const isNextButtonDisabled = () =>
    !cloneShipment.ble.every(item => item.deviceProfile !== "") &&
    step === 1 &&
    editField.isBLEEnabled?.value === "yes";
  const handleNext = () => {
    const fieldsToValidate = ["shipmentName", "startDate", "devicetype", "deviceId"];
  
    let isFormValid = true;
    let updatedFields = { ...editField };
  
    fieldsToValidate.forEach((field) => {
      const validator = IsRequiredValidation(editField[field]?.value || "");
      updatedFields[field] = { ...validator, value: editField[field]?.value };
  
      if (!validator.isValid) {
        isFormValid = false;
      }
    });
  
    dispatch(
      updateUI({
        key: "clone",
        value: {
          editField: updatedFields,
        },
      })
    );
  
    if (isFormValid) {
      dispatch(
        updateUI({
          key: "clone",
          value: {
            step: 3,
          },
        })
      );
    }
  };
  

  const handleSave = () => {
    dispatch(
      updateUI({
        key: "clone",
        value: {
          step: 1,
        },
      })
    );
  };

  const handleCancel = () => {
    dispatch(
      updateUI({
        key: "clone",
        value: {
          isClone: false,
          step: 1,
        },
      })
    );
  };

  const handleBackAndCancelButton = () => {
    dispatch(
      updateUI({
        key: "clone",
        value: {
          selectedProfile: {},
          step: 1,
        },
      })
    );
  };

  // --- UPDATED RETURN STATEMENT WITH NEW STRUCTURE ---
  return (
    <Modal
      className="d-flex flex-column justify-content-center align-items-center p-2 shipment-clone"
      title=""
      open={isCloneOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      width={{
        xs: "90%",
        sm: "80%",
        md: "90%",
        lg: "88%",
        xl: "85%",
        xxl: "80%",
      }}
      footer={() => {
        if (step === 2) {
          return [
            <button
              key="back"
              className="cancel"
              onClick={handleBackAndCancelButton}
            >
              Cancel
            </button>,
            <button
              key="submit"
              disabled={!cloneShipment?.selectedProfileId}
              className="update"
              onClick={handleSave}
            >
              Save
            </button>,
          ];
        }

        if (step === 3) {
          return [
            <button
              key="back"
              className="cancel"
              onClick={handleBackAndCancelButton}
            >
              Cancel
            </button>,
            <button
              key="submit"
            //  disabled={!isSaved}
              className="update"
              onClick={handleAdd}
            >
              Save
            </button>,
          ];
        }
        return [
          <button key="back" className="cancel" onClick={handleCancel}>
            Cancel
          </button>,
          <button disabled={isNextButtonDisabled()} key="submit" className="update" onClick={handleNext}>
            Next
          </button>,
        ];
      }}
    >
      {/* --- Fixed Header Section --- */}
      <div>
        {step !== 1 && (
          <button
            onClick={handleBackAndCancelButton}
            className="shipping-clone-back-button"
          >
            <ArrowLeftOutlined />
          </button>
        )}
        <div className="py-2">
          <div
            className="font-face-vzw"
          style={{
            fontWeight: 700,
            fontSize: "30px",
          }}
          >
            {editRecord?.record?.editorClone === "clone" ? "Clone Shipment" : "Edit Shipment"}
          </div>
        </div>
      </div>

      {/* --- Scrollable Content Section --- */}
      <div className="scrollable-content-hidden-scrollbar">
        {step === 1 && <ShipmentCloneStep1 />}
        {step === 2 && <ShipmentCloneStep2 />}
        {step === 3 && <ShipmentCloneStep3 />}
      </div>
    </Modal>
  );
}

export default CloneShipment;